<template>
  <div :id="id" class="panel-group">
    <PanelSlot @mounted="onPanelMounted($event)">
      <slot></slot>
    </PanelSlot>
  </div>
</template>

<script>
import PanelSlot from "./PanelSlot.vue";
export default {
  name: "bc-panels",
  components: {
    PanelSlot,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    onPanelMounted(event) {
      if (event) {
        // console.log("panel", event, "mounted");
      }
    },
  },
};
</script>

